export default class FromEmailAddressDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { created: new Date(json.created), expiredOn: json.expiredOn && new Date(json.expiredOn), verifiedDate: json.verifiedDate && new Date(json.verifiedDate) });
    }
    static toString(fromEmailAddress) {
        if (!fromEmailAddress) {
            return "";
        }
        return `${fromEmailAddress.fromName} <${fromEmailAddress.fromEmail}>`;
    }
    static get Types() {
        return {
            NoReplyFromEmailAddress: 1,
            DirectFromEmailAddress: 2,
            DelegateFromEmailAddress: 3,
        };
    }
}
